import React, { useState } from 'react'
import PermissionsForm from './PermissionsForm'
import { useParams } from 'react-router-dom';

const EditPermissionPage = () => {
  const { id } = useParams();
  
  
  
  return (
    <>
    currentPermissionId?(<PermissionsForm formType='edit' currentPermissionId={id} ></PermissionsForm>):''
     
    </>
  )
}

export default EditPermissionPage
